var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tppDateItemList" }, [
    _c("div", { staticClass: "flex" }, [
      _c("div", { staticClass: "tppDateItem" }, [
        _c("div", { staticClass: "txt" }, [
          _vm._v(
            _vm._s(
              _vm.$t("dashboard.integral") +
                "/" +
                _vm.$t("dashboard.integralTarget2")
            )
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "nums" }, [
          _c("span", { staticClass: "num1 blue" }, [
            _vm._v(
              _vm._s(
                _vm.paddingNum(_vm.sourceData.integral) == 0
                  ? "-"
                  : _vm.paddingNum(_vm.sourceData.integral)
              )
            ),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "num2" }, [
            _vm._v(
              "/" +
                _vm._s(
                  _vm.paddingNum(_vm.sourceData.integralTarget) == 0
                    ? "-"
                    : _vm.paddingNum(_vm.sourceData.integralTarget)
                )
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex" }, [
      _c("div", { staticClass: "tppDateItem" }, [
        _c("div", { staticClass: "txt" }, [
          _vm._v(_vm._s(_vm.$t("dashboard.achievementRate"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "nums" }, [
          _c(
            "span",
            {
              staticClass: "num1",
              style: "color: " + _vm.sourceData.color + ";",
            },
            [
              _vm._v(
                _vm._s(
                  _vm.sourceData.attainment
                    ? _vm.paddingNum(_vm.sourceData.attainment)
                    : "-"
                )
              ),
            ]
          ),
          _vm._v(" "),
          _vm.sourceData.attainment != undefined
            ? _c("span", { staticClass: "num2" }, [_vm._v("%")])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tppDateItem" }, [
        _c("div", { staticClass: "txt" }, [
          _vm._v(_vm._s(_vm.$t("dashboard.underachievedQuat"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "nums" }, [
          _c("span", { staticClass: "num1" }, [
            _vm._v(
              _vm._s(
                _vm.paddingNum(_vm.sourceData.integralTarget) == 0
                  ? "-"
                  : _vm.paddingNum(_vm.sourceData.unFinishIntegral)
              )
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }